import { ErrorPage } from 'components/error-handler/error-page';
import { TableColumnProps } from 'components/table/table-component/table-component';
import { lazy } from 'react';
import { ComplianceSection } from 'store/modules/compliance/compliance.reducer';

export const COMPLIANCE_CREATION_SUCCESS_MESSAGE =
  'Custom compliance standard added successfully';

export const COMPLIANCE_UPDATION_SUCCESS_MESSAGE =
  'Custom compliance standard updated successfully';

export const COMPLIANCE_DELETION_SUCCESS_MESSAGE =
  'Custom compliance standard deleted successfully';

export const CREATE_COMPLIANCE_TOOLTIP_TEXTS = {
  metaData: 'Name and Description are required',
  sections: 'Sections should have atleast one test',
};

export const HELPER_TEXTS = {
  STEP1:
    'Step 1 : Enter the Name and Description of your new compliance standard',
  STEP2:
    'Step 2 : Name your first section and click "Save" to get started. You can add sections and add tests to a section',
  SECTION_NAME: 'Section Name should be atleast 3 characters',
};

export type ComplianceStepId =
  | 'create-custom-compliance'
  | 'add-steps-and-tests'
  | 'summary-and-save';

export const createComplianceSteps = [
  {
    id: 'create-custom-compliance',
    label: 'Create Custom Compliance',
  },
  {
    id: 'add-steps-and-tests',
    label: 'Add Sections and Tests',
  },
  {
    id: 'summary-and-save',
    label: 'View Summary and Save',
  },
];

export const compliancePoliciesTableColumns: TableColumnProps[] = [
  {
    id: 'checkbox',
    title: '',
  },
  {
    id: 'name',
    title: 'Policy',
    position: 'left',
  },
  {
    id: 'severity',
    title: 'Severity',
    position: 'left',
  },
];

export const ComplianceComponent: Record<
  ComplianceStepId,
  React.LazyExoticComponent<() => JSX.Element>
> = {
  'create-custom-compliance': lazy(() =>
    import('./components/AddCompliance')
      .then((module) => ({
        default: module.AddCompliance,
      }))
      .catch(() => ({
        default: ErrorPage,
      })),
  ),
  'add-steps-and-tests': lazy(() =>
    import('./components/ComplianceSections')
      .then((module) => ({
        default: module.ComplianceSections,
      }))
      .catch(() => ({
        default: ErrorPage,
      })),
  ),
  'summary-and-save': lazy(() =>
    import('./components/ComplianceSummary')
      .then((module) => ({
        default: module.ComplianceSummary,
      }))
      .catch(() => ({
        default: ErrorPage,
      })),
  ),
};

interface ComplianceEditData {
  section_id: number;
  section_name: string;
  policy_name: string;
}

export const transformComplianceData = (data: ComplianceEditData[]) => {
  if (!data || !Array.isArray(data)) return [];
  try {
    const sectionMap: Map<number, ComplianceSection> = new Map();

    data.forEach(({ section_id, section_name, policy_name }) => {
      if (!sectionMap.has(section_id)) {
        sectionMap.set(section_id, {
          index: section_id,
          title: section_name,
          selectedPolicies: [],
        });
      }

      const section = sectionMap.get(section_id)!;
      section.selectedPolicies.push({
        position: section.selectedPolicies.length + 1,
        name: policy_name,
      });
    });

    return Array.from(sectionMap.values());
  } catch (e) {
    console.error(e);
    return [];
  }
};
